<template>
    <div class="freight-detail">
        <div class="freight-detail-title">不支持货到付款包邮</div>
        <el-table :data="freightTable" style="width: 100%; flex: 1" size="medium"
                  :header-cell-style="{fontWeight: 'normal', color: '#666', background: '#F6F6F6',fontSize: '16px',height:'60px'}"
                  :cell-style="{fontSize: '16px',color: '#333',height: '70px'}">
            <el-table-column prop="delivery" label="运送方式"  width="200px"></el-table-column>
            <el-table-column prop="delivery_t" label="送货到（国内）" align="left"></el-table-column>
            <el-table-column prop="first_thing" label="首件（件）" align="center" width="200px"></el-table-column>
            <el-table-column prop="first_cost" label="首费（元）" align="center" width="200px"></el-table-column>
            <el-table-column prop="add_thing" label="续件（件）" align="center" width="200px"></el-table-column>
            <el-table-column prop="add_cost" label="续费（元）" align="center" width="200px"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "FreightDetail",
        data(){
            return{
                freightTable:[
                    {
                        delivery:'快递',
                        delivery_t:'未被划分的地区将归于该模板下快递默认运费',
                    }
                ],
            }
        }
    }
</script>

<style scoped lang="scss">
.freight-detail{
    padding: 0 20px;
    .freight-detail-title{
        padding: 10px 0;
    }
}
</style>